import Icon from '@/Icon';

import Img from '@/legacy/components/img/ImgFrame';

type Props = {
	nationFlagImageUrl: string | null;
	/** [ISO-3166 alpha2 형식, GLOBAL, PICKED] */
	nationCode: 'GLOBAL' | 'PICKED' | string;
	className: string;
};

const Nation = ({ nationFlagImageUrl, nationCode, className }: Props) => {
	if (nationFlagImageUrl) return <Img frameClass={className} src={nationFlagImageUrl} />;
	if (nationCode === 'GLOBAL')
		return (
			<div className={className}>
				<Icon className={className} path="Sticker_Image_Global_32" />
			</div>
		);
	if (nationCode === 'PICKED')
		return (
			<div className={className}>
				<Icon className={className} path="Sticker_Country_48_Select" />
			</div>
		);
	return <div className={className} />;
};

export default Nation;
